import type { SerializedStyles } from '@emotion/react';
import { css } from '@emotion/react';
import dynamic from 'next/dynamic';
import type { EditorViewerProps } from '@/components/comm/EditorViewerComponent';
import ProgressLoading from '@/components/comm/progress/Loading';
import { breakpointMedium, breakpointSmall } from '@/constants/breakpoints';
import { colors } from '@/constants/colors';

const EditorViewerComponent = dynamic(() => import('@/components/comm/EditorViewerComponent'), {
  loading: () => <ProgressLoading size="64px" />,
  ssr: false,
});

const baseCss = css`
.toastui-editor-contents {
  p {
    font-size: 16px;

    @media (max-width: ${breakpointSmall}) {
      font-size: 13px;
    }
  }
  code {
    color: ${colors.arsenic};
  }
  table {
    width: 100%;
    font-size: 14px;

    @media (max-width: ${breakpointSmall}) {
      font-size: 12px;
    }
  }
  table th {
    background-color: ${colors.lightGrey5};
    color: ${colors.black};
    font-weight: 700;
    word-break: keep-all;
  }
  table td {
    padding: 5px 30px;
    word-break: keep-all;

    @media (max-width: ${breakpointMedium}) {
      padding: 5px 12px;
    }
  }
}
`;

const EditorViewer = ({
  overrideCss,
  ...props
}: EditorViewerProps & { overrideCss?: SerializedStyles }) => (
  <div css={[baseCss, overrideCss]}>
    <EditorViewerComponent {...props} />
  </div>
);

export default EditorViewer;
